import { useNavigate } from "react-router-dom";
import AuthContainer from "../components/AuthContainer/AuthContainer";
import CheckoutBox from "../components/Checkout/CheckoutBox";
import useOrganisation from "../store/Querys/useOrganisation";

const Checkout = () => {
  const navigate = useNavigate();

  const isAuthenticated = window.localStorage.getItem("accessToken") !== null;
  const { data: organizationsData } = useOrganisation({
    enabled: isAuthenticated,
  });
  const organization = organizationsData?.organizations?.[0];

  return (
    <AuthContainer>
      <CheckoutBox
        backBtnClick={() => navigate("/get-started")}
        oldOrganizationName={organization?.organizationName}
        orgId={organization?.id}
      />
    </AuthContainer>
  );
};

export default Checkout;
